const nailgunFeaturesZh = {
  // 4V 系列
  product_J_120_feature_1_title: '极致轻量化与人体工程学',
  product_J_120_feature_1_desc: '机身轻至 0.9kg，显著减轻长时间作业的手部疲劳。',
  product_J_120_feature_2_title: '无可比拟的电池续航',
  product_J_120_feature_2_desc: '单次充电支持 1000 次击发，续航性能傲视同类产品。',
  product_J_120_feature_3_title: '现代化通用快充',
  product_J_120_feature_3_desc: '采用通用快充接口，支持多种电源快速充电，随时随地补能。',
  product_J_120_feature_4_title: '三重作业安全保障',
  product_J_120_feature_4_desc: '集成安全触头、可视化储钉窗与 LED 指示灯，全方位保障安全。',
  product_J_120_feature_5_title: '75 分钟快充',
  product_J_120_feature_5_desc: '4V 1.5Ah 电池仅需 75 分钟即可充满，最大限度缩短等待时间。',

  product_J_125_feature_1_title: '0.7kg 羽量级机身设计',
  product_J_125_feature_1_desc: '仅 0.7kg 自重，比一瓶水还轻，确保精细作业轻松掌控。',
  product_J_125_feature_2_title: '1000 次超长击发续航',
  product_J_125_feature_2_desc: '单次充电击发 1000 次，强劲耐力无需频繁补能。',
  product_J_125_feature_3_title: '全能型钉种兼容',
  product_J_125_feature_3_desc: '全能型三合一，适配 53#, T50# 码钉及 47#/BN1810 直钉。',
  product_J_125_feature_4_title: '优化的安全与监控',
  product_J_125_feature_4_desc: '双重保险触头配合透明储钉窗，让作业更安全专注。',
  product_J_125_feature_5_title: '80 分钟充电循环',
  product_J_125_feature_5_desc: '随附 4V 1.5Ah 电池，80 分钟可充满，不间断作业的快速翻转保障。',

  product_J_139_feature_1_title: '极致轻量化与人体工程学',
  product_J_139_feature_1_desc: '机身轻至 0.9kg，显著减轻长时间作业的手部疲劳。',
  product_J_139_feature_2_title: '无可比拟的电池续航',
  product_J_139_feature_2_desc: '单次充电支持 1000 次击发，续航性能傲视同类产品。',
  product_J_139_feature_3_title: '现代化通用快充',
  product_J_139_feature_3_desc: '采用通用快充接口，支持多种电源快速充电，随时随地补能。',
  product_J_139_feature_4_title: '三重作业安全保障',
  product_J_139_feature_4_desc: '集成安全触头、可视化储钉窗与 LED 指示灯，全方位保障安全。',
  product_J_139_feature_5_title: '75 分钟快充',
  product_J_139_feature_5_desc: '4V 1.5Ah 电池仅需 75 分钟即可充满，最大限度缩短等待时间。',

  product_J_126_feature_1_title: '0.7kg 羽量级机身设计',
  product_J_126_feature_1_desc: '仅 0.7kg 自重，比一瓶水还轻，确保精细作业轻松掌控。',
  product_J_126_feature_2_title: '1000 次超长击发续航',
  product_J_126_feature_2_desc: '单次充电击发 1000 次，强劲耐力无需频繁补能。',
  product_J_126_feature_3_title: '全能型钉种兼容',
  product_J_126_feature_3_desc: '全能型三合一，适配 53#, T50# 码钉及 47#/BN1810 直钉。',
  product_J_126_feature_4_title: '优化的安全与监控',
  product_J_126_feature_4_desc: '双重保险触头配合透明储钉窗，让作业更安全专注。',
  product_J_126_feature_5_title: '80 分钟充电循环',
  product_J_126_feature_5_desc: '随附 4V 1.5Ah 电池，80 分钟可充满，不间断作业的快速翻转保障。',

 product_J_153_feature_1_title: '三合一全能紧固系统',
 product_J_153_feature_1_desc: '适配 T50#, 53# 码钉与 47# 直钉，全能覆盖施工需求。',
 product_J_153_feature_2_title: '超轻量化与电缆固定',
 product_J_153_feature_2_desc: '1.35kg 人体工程学设计，特有金属弹夹支持快速固线。',
 product_J_153_feature_3_title: '高速击发与持久续航',
 product_J_153_feature_3_desc: '每分钟 100 次高速击发，单次充电可击发 1800 枚钉子。',
 product_J_153_feature_4_title: '精准控制与安全保障',
 product_J_153_feature_4_desc: '无工具深度调节旋钮配合安全触头保险，防止误触发。',
 product_J_153_feature_5_title: '75 分钟快充',
 product_J_153_feature_5_desc: '4V 1.5Ah 电池 75 分钟快速充电，让软包项目全天顺利推进。',

  product_lk_4v_n50_feature_1_title: 'N 型结构钉范围（20–50 mm）',
  product_lk_4v_n50_feature_1_desc: '支持 20–50 mm N 型钉，适用于木框架、围栏和甲板板材紧固。',
  product_lk_4v_n50_feature_2_title: '重型 120 颗弹匣',
  product_lk_4v_n50_feature_2_desc: '容纳 120 颗 N 型钉，在大批量框架任务中显著减少补钉时间。',
  product_lk_4v_n50_feature_3_title: '0.88 kg 坚固机身',
  product_lk_4v_n50_feature_3_desc: '略重的 0.88 kg 机身，为 N 型结构钉提供所需的额外驱动力，同时控制振动。',
  product_lk_4v_n50_feature_4_title: '高扭矩顺序驱动',
  product_lk_4v_n50_feature_4_desc: '提供足够的动力，将 N 型钉以一致深度打入硬木框架和结构木材。',
  product_lk_4v_n50_feature_5_title: '2.0Ah 延长续航',
  product_lk_4v_n50_feature_5_desc: '4V 2.0Ah 电池充电间隔更长，对于户外框架和甲板安装非常重要。',

  product_lk_4v_b18_feature_1_title: 'B 型精装钉精度（10–18 mm）',
  product_lk_4v_b18_feature_1_desc: '发射 10–18 mm B 型钉，精细踢脚线、压条和薄面板固定，不开裂。',
  product_lk_4v_b18_feature_2_title: '110 颗弹匣容量',
  product_lk_4v_b18_feature_2_desc: '110 颗弹匣一次性完成整房踢脚线安装，无需中途补钉。',
  product_lk_4v_b18_feature_3_title: '窄体 256 mm 机身',
  product_lk_4v_b18_feature_3_desc: '256 mm 紧凑机身，室内线条和装饰施工时轻松进入角落和狭窄空间。',
  product_lk_4v_b18_feature_4_title: '顺滑顺序打钉',
  product_lk_4v_b18_feature_4_desc: '顺序模式沿精细装饰边缘谨慎定位，无过深打入风险。',
  product_lk_4v_b18_feature_5_title: '1.5Ah 电池 75 分钟快充',
  product_lk_4v_b18_feature_5_desc: '轻量 1.5Ah 电池保持工具灵巧，仅需 75 分钟即可充满。',

  product_lk_4v_c25_feature_1_title: 'C 型钉范围（12–25 mm）',
  product_lk_4v_c25_feature_1_desc: '兼容 12–25 mm C 型钉，覆盖从薄到中厚面板和线条紧固的多种场景。',
  product_lk_4v_c25_feature_2_title: '100 颗顺滑进钉弹匣',
  product_lk_4v_c25_feature_2_desc: '100 颗弹匣配合顺滑进钉机构，防止卡钉，保持打钉节奏稳定。',
  product_lk_4v_c25_feature_3_title: '均衡 0.77 kg 重量',
  product_lk_4v_c25_feature_3_desc: '0.77 kg 是 C 型钉枪理想的驱动力与使用舒适性的平衡点。',
  product_lk_4v_c25_feature_4_title: '精洁顺序钉位控制',
  product_lk_4v_c25_feature_4_desc: '顺序扳机控制让您沿精细木纹和装饰面精准打钉，不开裂。',
  product_lk_4v_c25_feature_5_title: '80 分钟充电随时就绪',
  product_lk_4v_c25_feature_5_desc: '4V 1.5Ah 电池 80 分钟可充满，全天室内线条项目均可胜任。',

  product_lk_4v_d30_feature_1_title: 'D 型钉强度（15–30 mm）',
  product_lk_4v_d30_feature_1_desc: '以可靠的深度控制驱动 15–30 mm D 型钉，适用于中型线条、套线和面板施工。',
  product_lk_4v_d30_feature_2_title: '90 颗 D 型弹匣',
  product_lk_4v_d30_feature_2_desc: '90 颗弹匣在弹匣容量与工具重量之间取得平衡，全天线条作业也舒适。',
  product_lk_4v_d30_feature_3_title: '2.0Ah 电池应对更硬材料',
  product_lk_4v_d30_feature_3_desc: '4V 2.0Ah 电池组为更致密的木线条和套线提供额外驱动力，不损耗续航。',
  product_lk_4v_d30_feature_4_title: '一致深度调节',
  product_lk_4v_d30_feature_4_desc: '可调驱钉深度，在不同木材密度上实现与面齐平或沉钉效果，不损伤表面。',
  product_lk_4v_d30_feature_5_title: '85 分钟快速充电',
  product_lk_4v_d30_feature_5_desc: '85 分钟充满，午饭时间换电池再充完全足够，持续高效施工。',

  product_lk_4v_e40_feature_1_title: 'E 型钉延伸范围（18–40 mm）',
  product_lk_4v_e40_feature_1_desc: '驱动 18–40 mm E 型钉穿透更厚的硬木线条，覆盖宽范围装饰深度。',
  product_lk_4v_e40_feature_2_title: '80 颗紧凑弹匣',
  product_lk_4v_e40_feature_2_desc: '80 颗弹匣针对较长 E 型钉优化，保持工具尺寸紧凑。',
  product_lk_4v_e40_feature_3_title: '0.83 kg 均衡机身',
  product_lk_4v_e40_feature_3_desc: '在 0.83 kg 机身内实现重型打钉，精心平衡设计让长时间使用不伤手腕。',
  product_lk_4v_e40_feature_4_title: '精准深驱顺序模式',
  product_lk_4v_e40_feature_4_desc: '顺序扳机对更长钉子在可见木面上的精准定位提供完全控制。',
  product_lk_4v_e40_feature_5_title: '90 分钟充电，2.0Ah 容量',
  product_lk_4v_e40_feature_5_desc: '4V 2.0Ah 电池支持 40 mm 打钉的较高能耗，90 分钟即可充满。',

  // 20V 系列
  product_J_128_feature_1_title: '20V F 钉专业动力（15–30 mm）',
  product_J_128_feature_1_desc: '升级为 20V，这款 F 型钉枪以专业级动力驱钉，适合大批量室内线条高强度施工。',
  product_J_128_feature_2_title: '专业级 2.0Ah 20V 电池',
  product_J_128_feature_2_desc: '20V 2.0Ah 锂电池在致密硬木和厚套线中也能输出强劲一致的驱动力。',
  product_J_128_feature_3_title: '110 颗专业弹匣',
  product_J_128_feature_3_desc: '装载 110 颗 F 型精装钉，大规模室内线条安装施工不间断。',
  product_J_128_feature_4_title: '60 分钟极速充电',
  product_J_128_feature_4_desc: '20V 电池仅需 60 分钟充满，是全系最快，非常适合高强度工地。',
  product_J_128_feature_5_title: '2 年质保覆盖',
  product_J_128_feature_5_desc: '提供完整 24 个月质保，专为每天依赖工具的专业用户设计。',

  product_J_129_feature_1_title: '20V F 钉专业动力（15–30 mm）',
  product_J_129_feature_1_desc: '升级为 20V，这款 F 型钉枪以专业级动力驱钉，适合大批量室内线条高强度施工。',
  product_J_129_feature_2_title: '专业级 2.0Ah 20V 电池',
  product_J_129_feature_2_desc: '20V 2.0Ah 锂电池在致密硬木和厚套线中也能输出强劲一致的驱动力。',
  product_J_129_feature_3_title: '110 颗专业弹匣',
  product_J_129_feature_3_desc: '装载 110 颗 F 型精装钉，大规模室内线条安装施工不间断。',
  product_J_129_feature_4_title: '60 分钟极速充电',
  product_J_129_feature_4_desc: '20V 电池仅需 60 分钟充满，是全系最快，非常适合高强度工地。',
  product_J_129_feature_5_title: '2 年质保覆盖',
  product_J_129_feature_5_desc: '提供完整 24 个月质保，专为每天依赖工具的专业用户设计。',

  product_J_133_feature_1_title: '二合一多功能设计',
  product_J_133_feature_1_desc: '完美兼容 18GA F型直钉与 55# 码钉，一机多用。',
  product_J_133_feature_2_title: '精准深度调节与可视化视窗',
  product_J_133_feature_2_desc: '无工具深度调节旋钮配合可视化储钉窗。',
  product_J_133_feature_3_title: '多重安全保障与照明',
  product_J_133_feature_3_desc: '双重保险安全触头防止误触发，内置 LED 工作灯。',
  product_J_133_feature_4_title: '高效持久作业',
  product_J_133_feature_4_desc: '每分钟 60 次高速击发，单次充电续航 1000 枚钉子。',
  product_J_133_feature_5_title: '减振握把设计',
  product_J_133_feature_5_desc: '防振握把设计吸收较长 T 钉的工具后坐力，减少重型橱柜作业的疲劳。',

  product_J_145_feature_1_title: '20V F 钉专业动力（15–30 mm）',
  product_J_145_feature_1_desc: '升级为 20V，这款 F 型钉枪以专业级动力驱钉，适合大批量室内线条高强度施工。',
  product_J_145_feature_2_title: '专业级 2.0Ah 20V 电池',
  product_J_145_feature_2_desc: '20V 2.0Ah 锂电池在致密硬木和厚套线中也能输出强劲一致的驱动力。',
  product_J_145_feature_3_title: '110 颗专业弹匣',
  product_J_145_feature_3_desc: '装载 110 颗 F 型精装钉，大规模室内线条安装施工不间断。',
  product_J_145_feature_4_title: '60 分钟极速充电',
  product_J_145_feature_4_desc: '20V 电池仅需 60 分钟充满，是全系最快，非常适合高强度工地。',
  product_J_145_feature_5_title: '2 年质保覆盖',
  product_J_145_feature_5_desc: '提供完整 24 个月质保，专为每天依赖工具的专业用户设计。',

  product_J_147_feature_1_title: 'N 钉框架动力（40–90 mm）',
  product_J_147_feature_1_desc: '支持 40–90 mm N 型框架钉，适用于甲板板材、围栏和重型结构框架施工。',
  product_J_147_feature_2_title: '最大 150 颗框架弹匣',
  product_J_147_feature_2_desc: '150 颗弹匣是全系列最高容量，为框架和甲板施工提供最大生产效率。',
  product_J_147_feature_3_title: '4.0Ah 全天框架作业',
  product_J_147_feature_3_desc: '20V 4.0Ah 电池支持超长框架作业时间，单次充电可驱动数百颗 90 mm 钉。',
  product_J_147_feature_4_title: '坚固 1.78 kg 框架机身',
  product_J_147_feature_4_desc: '重型 1.78 kg 机身承受大型 N 型框架钉驱动的后坐力，不影响瞄准精度。',
  product_J_147_feature_5_title: '工业级 87 dB 噪音控制',
  product_J_147_feature_5_desc: '框架钉枪噪音控制在 ≤87 dB，符合专业承包商大多数工地噪音法规。',

  product_J_150_feature_1_title: '氮气弹簧传动技术',
  product_J_150_feature_1_desc: '采用压缩氮气弹簧结构，实现零延迟即时击发。',
  product_J_150_feature_2_title: '卓越的单次充电续航',
  product_J_150_feature_2_desc: '单次充电（2.0Ah 电池）可击发多达 1200 枚钉子。',
  product_J_150_feature_3_title: '18GA 二合一通用性',
  product_J_150_feature_3_desc: '完美兼容 18GA 90# 码钉与 18GA F 直钉。',
  product_J_150_feature_4_title: '峰值作业效率',
  product_J_150_feature_4_desc: '高达每分钟 120 次的击发频率。',
  product_J_150_feature_5_title: '无工具深度调节与快速除卡',
  product_J_150_feature_5_desc: '精准调节旋钮确保一致沉头效果，开放式枪头设计可瞬间除卡。',

  product_J_156_feature_1_title: '二合一多功能设计',
  product_J_156_feature_1_desc: '完美兼容 18GA F型直钉与 55# 码钉，一机多用。',
  product_J_156_feature_2_title: '精准深度调节与可视化视窗',
  product_J_156_feature_2_desc: '无工具深度调节旋钮配合可视化储钉窗。',
  product_J_156_feature_3_title: '多重安全保障与照明',
  product_J_156_feature_3_desc: '双重保险安全触头防止误触发，内置 LED 工作灯。',
  product_J_156_feature_4_title: '高效持久作业',
  product_J_156_feature_4_desc: '每分钟 60 次高速击发，单次充电续航 1000 枚钉子。',
  product_J_156_feature_5_title: '减振握把设计',
  product_J_156_feature_5_desc: '防振握把设计吸收较长 T 钉的工具后坐力，减少重型橱柜作业的疲劳。',

  product_lk_20v_d70_feature_1_title: 'D 钉深驱（30–70 mm）',
  product_lk_20v_d70_feature_1_desc: '驱动 30–70 mm D 型钉，适用于厚结构线条、门框安装和重型木面板固定。',
  product_lk_20v_d70_feature_2_title: '105 颗坚固弹匣',
  product_lk_20v_d70_feature_2_desc: '105 颗弹匣在轻便携带性与持续结构线条施工弹药之间取得平衡。',
  product_lk_20v_d70_feature_3_title: '4.0Ah 电池应对密集驱钉',
  product_lk_20v_d70_feature_3_desc: '20V 4.0Ah 提供将 70 mm D 型钉打入硬木所需的额外能量，保持一致的深度。',
  product_lk_20v_d70_feature_4_title: '可旋转排气偏转器',
  product_lk_20v_d70_feature_4_desc: '可旋转排气口将气流远离面部和工作面，是高强度使用的贴心设计。',
  product_lk_20v_d70_feature_5_title: '60 分钟极速充电',
  product_lk_20v_d70_feature_5_desc: '即使是大容量 4.0Ah 电池，60 分钟也能充满，休息后迅速恢复施工。',

  product_lk_20v_e80_feature_1_title: 'E 钉 20V 最大范围（35–80 mm）',
  product_lk_20v_e80_feature_1_desc: '驱动 35–80 mm E 型钉穿透厚硬木、复合木材和重型结构框架材料。',
  product_lk_20v_e80_feature_2_title: '100 颗重型弹匣',
  product_lk_20v_e80_feature_2_desc: '100 颗 E 型长钉弹匣，专为大批量结构面板和厚板打钉设计。',
  product_lk_20v_e80_feature_3_title: '4.0Ah 强力电池',
  product_lk_20v_e80_feature_3_desc: '4.0Ah 电池单次充电即可维持将 80 mm 钉打入整面结构墙体各截面的驱动力。',
  product_lk_20v_e80_feature_4_title: '橡胶包覆握把应对高后坐力',
  product_lk_20v_e80_feature_4_desc: '包塑橡胶握把吸收 80 mm 打钉的显著后坐力，保持瞄准精度，减少操作者疲劳。',
  product_lk_20v_e80_feature_5_title: '1.72 kg 重型机架',
  product_lk_20v_e80_feature_5_desc: '1.72 kg 机身吸收驱钉压力，在重型框架施工中保持钉枪方向一致，结果专业。',

  product_lk_20v_g100_feature_1_title: 'G 钉最强动力（45–100 mm）',
  product_lk_20v_g100_feature_1_desc: '驱动 45 至 100 mm 最长 G 型钉，适用于重型木材、柱式框架和厚实结构甲板。',
  product_lk_20v_g100_feature_2_title: '95 颗最长钉弹匣',
  product_lk_20v_g100_feature_2_desc: '容纳 95 颗最长 G 型钉，为结构重型框架和柱梁施工提供高产能保障。',
  product_lk_20v_g100_feature_3_title: '4.0Ah 大容量续航',
  product_lk_20v_g100_feature_3_desc: '4.0Ah 20V 电池单次充电可驱动数百颗 100 mm 钉，跟上最繁忙的框架施工队节奏。',
  product_lk_20v_g100_feature_4_title: '55 分钟超快充电',
  product_lk_20v_g100_feature_4_desc: '仅需 55 分钟即可充满，是全系最快，为大型结构框架项目最小化停机时间。',
  product_lk_20v_g100_feature_5_title: '1.92 kg 专业框架机身',
  product_lk_20v_g100_feature_5_desc: '1.92 kg 机身提供将 100 mm 钉笔直打入结构木材所需的质量和稳定性。',

  // AC 系列
  product_J_112_feature_1_title: '恒定持久的驱动力',
  product_J_112_feature_1_desc: '专为高性能交流电作业打造，确保每一次击发动力恒定。',
  product_J_112_feature_2_title: '精准深度调节系统',
  product_J_112_feature_2_desc: '配备深度调节旋钮，确保针对不同硬度木材均有完美沉头效果。',
  product_J_112_feature_3_title: '全能二合一紧固表现',
  product_J_112_feature_3_desc: '完美兼容 18GA F型直钉与 18GA 55# 码钉。',
  product_J_112_feature_4_title: '工业级稳固结构',
  product_J_112_feature_4_desc: '1.4kg 平衡机身配合安全保险触头，耐用且精准。',
  product_J_112_feature_5_title: 'CE 认证安全运行',
  product_J_112_feature_5_desc: 'CE 安全认证确保这款 AC 钉枪满足专业使用的所有欧盟电气和安全标准。',

  product_J_115_feature_1_title: '0.6kg 巅峰轻量化设计',
  product_J_115_feature_1_desc: '0.6kg 超轻机身刷新便携标杆，长时间作业完全不累手。',
  product_J_115_feature_2_title: '有源动力带来的无限一致性',
  product_J_115_feature_2_desc: '插电连接确保动力恒定强劲，彻底杜绝锂电工具的动力衰减。',
  product_J_115_feature_3_title: '全能三合一紧固系统',
  product_J_115_feature_3_desc: '完美适配 53#, T50# 码钉及 47# 直钉，应对多种场景。',
  product_J_115_feature_4_title: '强化安全与可视化监控',
  product_J_115_feature_4_desc: '安全保险触头配合大面积透明窗，确保安全且掌控余钉量。',
  product_J_115_feature_5_title: '1.85 kg 专业级机身',
  product_J_115_feature_5_desc: '1.85 kg 机身经久耐用，专为日常专业高量线条施工设计。',

  product_J_118_feature_1_title: '0.6kg 巅峰轻量化设计',
  product_J_118_feature_1_desc: '0.6kg 超轻机身刷新便携标杆，长时间作业完全不累手。',
  product_J_118_feature_2_title: '有源动力带来的无限一致性',
  product_J_118_feature_2_desc: '插电连接确保动力恒定强劲，彻底杜绝锂电工具的动力衰减。',
  product_J_118_feature_3_title: '全能三合一紧固系统',
  product_J_118_feature_3_desc: '完美适配 53#, T50# 码钉及 47# 直钉，应对多种场景。',
  product_J_118_feature_4_title: '强化安全与可视化监控',
  product_J_118_feature_4_desc: '安全保险触头配合大面积透明窗，确保安全且掌控余钉量。',
  product_J_118_feature_5_title: '1.85 kg 专业级机身',
  product_J_118_feature_5_desc: '1.85 kg 机身经久耐用，专为日常专业高量线条施工设计。',

  product_J_119_feature_1_title: '0.6kg 巅峰轻量化设计',
  product_J_119_feature_1_desc: '0.6kg 超轻机身刷新便携标杆，长时间作业完全不累手。',
  product_J_119_feature_2_title: '有源动力带来的无限一致性',
  product_J_119_feature_2_desc: '插电连接确保动力恒定强劲，彻底杜绝锂电工具的动力衰减。',
  product_J_119_feature_3_title: '全能三合一紧固系统',
  product_J_119_feature_3_desc: '完美适配 53#, T50# 码钉及 47# 直钉，应对多种场景。',
  product_J_119_feature_4_title: '强化安全与可视化监控',
  product_J_119_feature_4_desc: '安全保险触头配合大面积透明窗，确保安全且掌控余钉量。',
  product_J_119_feature_5_title: '1.85 kg 专业级机身',
  product_J_119_feature_5_desc: '1.85 kg 机身经久耐用，专为日常专业高量线条施工设计。',

  product_J_123_feature_1_title: '0.71kg 羽量级紧凑设计',
  product_J_123_feature_1_desc: '仅 0.71kg 机身，同类中最轻便的有源钉枪，单手操作不累手。',
  product_J_123_feature_2_title: '无限续航支持持续作业',
  product_J_123_feature_2_desc: '交流电直供确保动力恒定不衰减，彻底告别充电等待。',
  product_J_123_feature_3_title: '全能三合一紧固表现',
  product_J_123_feature_3_desc: '完美兼容 53#, T50# 码钉及 47# 直钉，应对多种场景。',
  product_J_123_feature_4_title: '集成安全与可视化监控',
  product_J_123_feature_4_desc: '安全触头保险防止误触发，可视化储钉窗实时监控余量。',
  product_J_123_feature_5_title: '2.15 kg 框架级机身',
  product_J_123_feature_5_desc: '2.15 kg 工业机身吸收框架级后坐力，成排驱动 90 mm 钉时依然保持精准。',

  product_lk_ac_b50_feature_1_title: 'AC B 钉连续驱动（20–50 mm）',
  product_lk_ac_b50_feature_1_desc: '持续 AC 电源驱动 20–50 mm B 型钉，非常适合生产环境和大批量线条工坊。',
  product_lk_ac_b50_feature_2_title: '850W 稳定驱动电机',
  product_lk_ac_b50_feature_2_desc: '一致的 850W 电机输出防止逐发深度变化，对专业收尾品质至关重要。',
  product_lk_ac_b50_feature_3_title: '120 颗 B 型弹匣',
  product_lk_ac_b50_feature_3_desc: '每次装载 120 颗 B 型钉，支持室内套线和楼梯线条长时间施工无需停机。',
  product_lk_ac_b50_feature_4_title: '插电即用可靠性',
  product_lk_ac_b50_feature_4_desc: '无需电池，无停机，AC 电源设计非常适合有可靠电源的工坊环境。',
  product_lk_ac_b50_feature_5_title: '1.88 kg 工坊级机身',
  product_lk_ac_b50_feature_5_desc: '1.88 kg 坚固机身，适合工坊环境对耐久性和一致性的最高要求。',

  product_lk_ac_c60_feature_1_title: 'AC C 钉顶冠线条（25–60 mm）',
  product_lk_ac_c60_feature_1_desc: '通过 AC 电源持续驱动 25–60 mm C 型钉，非常适合大批量顶冠线条安装。',
  product_lk_ac_c60_feature_2_title: '900W 顶冠线条电机',
  product_lk_ac_c60_feature_2_desc: '900W AC 电机提供将 C 型钉打入斜角顶冠线条材料不反弹所需的力量。',
  product_lk_ac_c60_feature_3_title: '130 颗整房弹匣',
  product_lk_ac_c60_feature_3_desc: '130 颗弹匣可完成整房顶冠线条安装，一次装钉无需中途补充。',
  product_lk_ac_c60_feature_4_title: '顶冠施工斜角嘴头',
  product_lk_ac_c60_feature_4_desc: '斜角嘴头设计改善进入顶冠线条角落的可达性，确保在天花板斜角处齐平打钉。',
  product_lk_ac_c60_feature_5_title: '1.95 kg 有绳专业机身',
  product_lk_ac_c60_feature_5_desc: '1.95 kg 机身提供精准头顶顶冠线条打钉所需的质量稳定性。',

  product_lk_ac_d70_feature_1_title: 'AC D 钉深驱（30–70 mm）',
  product_lk_ac_d70_feature_1_desc: 'AC 电源持续驱动 30–70 mm D 型钉，适用于致密门框、厚实结构线条和挑檐板。',
  product_lk_ac_d70_feature_2_title: '950W 高扭矩 AC 电机',
  product_lk_ac_d70_feature_2_desc: '950W 电机无论木材密度或纹理方向如何，都能将 70 mm 钉打至一致深度。',
  product_lk_ac_d70_feature_3_title: '105 颗工业弹匣',
  product_lk_ac_d70_feature_3_desc: '每次装载 105 颗 D 型钉，支持工坊级门框和结构线条生产规模。',
  product_lk_ac_d70_feature_4_title: '防卡钉进钉系统',
  product_lk_ac_d70_feature_4_desc: '先进进钉机构防止驱动较长 70 mm D 型钉穿透致密硬木时卡钉。',
  product_lk_ac_d70_feature_5_title: '2.08 kg 生产级重量',
  product_lk_ac_d70_feature_5_desc: '2.08 kg 坚固机身吸收成千上万次 70 mm 钉打入的冲击力，保持工具对准。',

  product_lk_ac_e80_feature_1_title: 'AC E 钉重型结构（35–80 mm）',
  product_lk_ac_e80_feature_1_desc: '使用无限 220V AC 电源将 35–80 mm E 型钉打入最硬的结构材料。',
  product_lk_ac_e80_feature_2_title: '1000W 最大 AC 功率',
  product_lk_ac_e80_feature_2_desc: '全功率 1000W 电机长时间作业驱动大型 80 mm E 型钉，无动力衰减。',
  product_lk_ac_e80_feature_3_title: '100 颗 E 型弹匣',
  product_lk_ac_e80_feature_3_desc: '每次装载 100 颗 E 型钉，为持续结构面板安装和重型木框架施工而设计。',
  product_lk_ac_e80_feature_4_title: '双重安全扳机系统',
  product_lk_ac_e80_feature_4_desc: '双重动作安全扳机防止大型 80 mm 结构钉意外射出，安全操作。',
  product_lk_ac_e80_feature_5_title: '2.18 kg 结构级机架',
  product_lk_ac_e80_feature_5_desc: '2.18 kg 是 AC 系列最重机身，吸收 80 mm 结构打钉驱动的最大后坐力。',

  product_lk_ac_g100_feature_1_title: 'AC G 钉最强 100 mm 驱动',
  product_lk_ac_g100_feature_1_desc: '最强大的 AC 钉枪，持续驱动 45–100 mm G 型钉，满足最重型结构框架需求。',
  product_lk_ac_g100_feature_2_title: '1200W 工业电机',
  product_lk_ac_g100_feature_2_desc: '1200W 电机是整个钉枪系列最高功率输出，硬木中驱动 100 mm 钉毫不犹豫。',
  product_lk_ac_g100_feature_3_title: '95 颗 G 型工业弹匣',
  product_lk_ac_g100_feature_3_desc: '95 颗最长 G 型钉装载就绪，穿透最厚结构木材和重型甲板板材。',
  product_lk_ac_g100_feature_4_title: '每秒 1.5 发工业速度',
  product_lk_ac_g100_feature_4_desc: '即使是 100 mm 钉也能达到每秒 1.5 发，重型木框架施工队的工业速度。',
  product_lk_ac_g100_feature_5_title: '2.35 kg 最大负载机身',
  product_lk_ac_g100_feature_5_desc: '2.35 kg 是最重钉枪，专为最大结构打钉设计，吸收全天驱动 100 mm 钉的强烈后坐力。',
  // 钉枪配件翻译 - 4V系列
  //nail_4v_acc_1_name: '4V 2Ah 锂电池', nail_4v_acc_1_desc: '超轻设计，约击发800颗钉，约90分钟充满，兼容全系4V锂电工具',
  //nail_4v_acc_2_name: '4V USB快速充电器', nail_4v_acc_2_desc: 'Type-C接口快充，双LED充电状态指示，兼容全系4V锂电工具',
  //nail_4v_acc_3_name: '专用收纳箱', nail_4v_acc_3_desc: 'ABS硬壳+EVA泡沫精准定型，完全适配本系列产品外形，防震防尘防潮',
  //nail_4v_acc_4_name: '配套钉（约1000支/盒）', nail_4v_acc_4_desc: '镀锌高强度钢制钉，适合多种木材场景，定期更换确保打钉效果',
  //nail_4v_acc_5_name: '安全防护眼镜', nail_4v_acc_5_desc: '聚碳酸酯防冲击镜片，防雾镀层，符合EN166施工安全规范，轻量舒适',
  //nail_4v_acc_6_name: '旋转腰带挂钩夹', nail_4v_acc_6_desc: '304不锈钢旋转卡扣，360°灵活旋转，快挂快取，适合高频施工场景',
  //nail_4v_acc_7_name: '清洁保养套件', nail_4v_acc_7_desc: '含防锈润滑油、细毛清洁刷、擦拭布，定期使用延长工具使用寿命',
  //nail_4v_acc_8_name: '使用说明手册', nail_4v_acc_8_desc: '中英日三语操作指引，含安全警示、故障排查及全套配件示意图',
  //nail_4v_acc_9_name: '超紧凑型弹夹', nail_4v_acc_9_desc: '100 枚容量可视化弹夹',
  // 20V系列
  nail_20v_acc_1_name: '20V 4Ah 锂电池', nail_20v_acc_1_desc: '大容量设计，约击发2000颗钉，约60分钟充满，兼容全系20V锂电工具',
  nail_20v_acc_2_name: '20V三段LED快速充电器', nail_20v_acc_2_desc: '三段LED充电进度显示，过充自动截止，兼容全系20V锂电工具',
  nail_20v_acc_3_name: '专用收纳箱', nail_20v_acc_3_desc: 'ABS硬壳+EVA泡沫精准定型，完全适配本系列产品外形，防震防尘防潮',
  nail_20v_acc_4_name: '配套钉（约1000支/盒）', nail_20v_acc_4_desc: '高强度镀锌钢制，适合多种木材场景应用，定期更换保持最佳效果',
  nail_20v_acc_5_name: '安全防护眼镜', nail_20v_acc_5_desc: '聚碳酸酯防冲击镜片，防雾镀层，符合EN166施工安全规范，轻量舒适',
  nail_20v_acc_6_name: '旋转腰带挂钩夹', nail_20v_acc_6_desc: '304不锈钢旋转卡扣，360°灵活旋转，快挂快取，适合高频施工场景',
  nail_20v_acc_7_name: '清洁保养套件', nail_20v_acc_7_desc: '含防锈润滑油、细毛清洁刷、擦拭布，定期使用延长工具使用寿命',
  nail_20v_acc_8_name: '使用说明手册', nail_20v_acc_8_desc: '中英日三语操作指引，含安全警示、故障排查及全套配件示意图',
  // AC系列
  nail_ac_acc_1_name: 'AC 2米重型更换电源线', nail_ac_acc_1_desc: '3芯重型编织护套线，耐弯折耐磨损，专为工业级有线钉枪长时间作业设计',
  nail_ac_acc_2_name: '电涌防护插排', nail_ac_acc_2_desc: '内置电涌保护芯片，带通断开关，过载自动断电，保护工具安全使用',
  nail_ac_acc_3_name: '专用收纳箱', nail_ac_acc_3_desc: 'ABS硬壳+EVA泡沫定型，完全适配本系列外形，抗冲击耐搬运',
  nail_ac_acc_4_name: '配套钉（约500支/盒）', nail_ac_acc_4_desc: '镀锌高强度钢制钉，适合多种木材场景，定期更换确保打钉效果',
  nail_ac_acc_5_name: '安全防护眼镜', nail_ac_acc_5_desc: '聚碳酸酯防冲击宽幅镜片，防雾涂层，全包覆侧护翼，符合EN166安全标准',
  nail_ac_acc_6_name: '工作台壁挂存储支架', nail_ac_acc_6_desc: '重型钢制壁挂存储架，快速存取钉枪，防倒伏稳定摆放',
  nail_ac_acc_7_name: '清洁保养套件', nail_ac_acc_7_desc: '含防锈润滑油、铜丝清洁刷、干擦布，维护枪嘴顺畅不积垢',
  nail_ac_acc_8_name: '使用说明手册', nail_ac_acc_8_desc: '中英日三语操作说明，含维护周期、故障排查及配件更换指引',
};

export default nailgunFeaturesZh;
